import RoomItem from './RoomItem';
import { Icons, SearchParams, YadoHotel, YadoRoom } from '../types';

type RoomListProps = {
  hotel: YadoHotel;
  rooms: YadoRoom[];
  icons: Icons;
  query: SearchParams;
  nearestResortCode: string;
};

const RoomList: React.FC<RoomListProps> = ({ hotel, rooms, icons, query, nearestResortCode }) => {
  return (
    <div>
      {rooms?.map(room => (
        <RoomItem key={room.id} hotel={hotel} room={room} icons={icons} query={query} nearestResortCode={nearestResortCode} />
      ))}
    </div>
  );
};

export default RoomList;
